import React from "react";
import './Header.css'
import { Link } from 'react-scroll'
 
const Header = () => {
  return (
    <section className='header-container'>
      <Link 
      className="link" 
      to="/" 
      spy={true} 
      smooth={true} 
      offset={50} 
      duration={500} 
    >// Home</Link>
    <Link 
      className="link" 
      to="about" 
      spy={true} 
      smooth={true} 
      offset={-30} 
      duration={500} 
    >// About</Link>
    <Link 
      className="link" 
      to="projects" 
      spy={true} 
      smooth={true} 
      offset={150} 
      duration={500} 
    >// Projects</Link>
    <Link 
      className="link" 
      to="tools" 
      spy={true} 
      smooth={true} 
      offset={-50} 
      duration={500} 
    >// Tools</Link>
    <Link 
      className="link" 
      to="contact-container" 
      spy={true} 
      smooth={true} 
      offset={50} 
      duration={500} 
    >// Contact</Link>
    </section>
  )
} 

export default Header